import { ProjectStatus } from '@eiq/shared/data';

import { ProjectType } from '@empathy/global/data';

import { ProfileSurvey } from './profile-survey.model';
import { ProjectProgress } from './project-progress.model';
import { ResearchMethod } from './research-method.model';

export class Project {
  id: string;
  baseGuestViewerUrl?: string;
  clientId: string;
  name: string;
  brief?: string;
  createdDateTime: Date;
  updatedDateTime: Date;
  publishedDateTime: Date;
  archivedDateTime: Date;
  projectStatus: ProjectStatus;
  projectTypeId: ProjectType;
  systemInd: boolean;
  methods?: ResearchMethod[];
  profileSurvey?: ProfileSurvey;
  tags: string[];
  clientIntakeFormInd: boolean;
  aiReference: string;
  draftAllowedInd?: boolean;
  projectProgress: ProjectProgress;
  completedPanelistIds: string[];
  quotaTerminatedPanelistIds: string[];
  securityTerminatedPanelistIds: string[];
  duplicateTerminatedPanelistIds: string[];
  qualityTerminatedPanelistIds: string[];
  profileTerminatedPanelistIds: string[];
}
